/* 问卷调查-模块API */

import { GET, GETNEW, POST, POSTNEW, PUT, DELETE, download, uploading, POSTFormData, EXPORT, EXPORTNEW } from '@/request/http'

// 分页获取问卷回收信息
export const getQuestionnaireAnswerPage = p => POST('/questionnaire/answer/page', p)

// 分页获取问卷历史回收信息
export const getQuestionnaireHistoryAnswerPage = p => POST('/questionnaire/answerHistory/page', p)

// 分页教师查询所有数据
export const getTEAQuestionnaireAnswerPage = p => POSTNEW('/questionnaire/answer/teacherPage', p)

// 标记
export const questionnaireAnswerMarker = p => POST('/questionnaire/answer/marker', p)

// 生成自习证
export const createzixizheng = p => GET('/questionnaire/answer/autoCheck', p)

// 更新
export const questionnaireAnswerUpdate = p => PUT('/questionnaire/answer', p)
// 更新
export const questionnaireAnswerSubmit = p => POST('/questionnaire/answer', p)
// 获取问卷
export const getQuestionnairePage = p => GET('/questionnaire/page', p)

//修改问卷信息
export const updateQuestionInfo = p => PUT('/questionnaire/questionResult', p)

//导出
export const questionnaireAnswerExport = p => EXPORT('/questionnaire/answer/export', p, 5)
//历史导出
export const questionnaireHistoryAnswerExport = p => EXPORT('/questionnaire/answerHistory/export', p, 5)

//教师问卷导出
export const questionnaireAnswerTEAExport = p => EXPORTNEW('/questionnaire/answer/exportTeacher', p, 5)

//删除
export const delQuestionnaireAnswer = p => DELETE('/questionnaire/answer', p, 5)

//根据id查询答案详情
export const getQuestionnaireAnswerById = p => GET('/questionnaire/answer/getById', p, 5)
//根据id查询历史答案详情
export const getQuestionnaireHistoryAnswerById = p => GET('/questionnaire/answerHistory/getById', p, 5)

//检查是否合格
export const questionnaireAnswerCheck = p => GET('/questionnaire/answer/autoCheck', p, 5)

//根据id查询答案详情
export const getQuestionnaireAnswerById2 = p => GET('/questionnaire/answer/getById', p, 5)
// 更新
export const questionnaireAnswerUpdate2 = p => PUT('/questionnaire/answer/updateReturnData', p)
//返校人数统计
export const getQuestionnaireStatistics = p => GET('/questionnaire/common/statistics/overview', p, 5)

//各院系返校人数统计
export const getQuestionnaireStatisticsFacultyNum = p => GET('/questionnaire/common/statistics/facultyNum', p, 5)

// 根据大学id或者根据大学id和学院id获取相应的学院和辅导员信息或者辅导员信息
export const getInstructorInfo2 = p => POST('/counselor/counselor-info/findList/groupbyfac', p, 5)

//学生返校统计(新)-总览模块-返校码模块-院校模块
export const getBackReportCount = p => GETNEW('/questionnaire/questionResult/overView/get', p, 5)
//学生返校统计(新)-院系返校模块
export const getBackReportByDegree = p => POSTNEW('/questionnaire/questionResult/bkAndYjsAgreeNum/get', p, 5)
//学生返校统计(新)-当日时间段模块
export const getBackReportByDate = p => POSTNEW('/questionnaire/questionResult/toDayAgreeNum/get', p, 5)
//核酸检测统计分页查询
export const getNucleicStatistics = p => POSTNEW('/questionnaire/scan-code/page', p, 5)
//获取所有检测轮次列表
export const getNucleicRounds = p => GETNEW('/questionnaire/scan-config/list', p, 5)
//获取所有检测轮次列表
export const exportAllNucleic = p => EXPORTNEW('/questionnaire/scan-code/export', p, 5)

// 获取学生数据（根据id）
export const idGetStudentInfo = p => GET('/studentv2/basic-info/get', p, 5)

// 核酸扫码提交
export const nucleicScanSave = p => POST('/questionnaire/scan-code/save', p, 5)

// 获取当前生效的扫码配置
export const scanConfigEffect = p => GET('/questionnaire/scan-config/effect', p, 5)
// 获取核酸公寓信息
export const getApartmentList = p => GETNEW('/questionnaire/scan-dorm/list', p, 5)

// 获取公寓信息
export const getApartmentInfo = p => GET('/questionnaire/scan-dorm/join-list', p, 5)
// 获取核酸公寓信息
export const getNucleticDetail = p => GETNEW('/questionnaire/scan-code/get/student/join-info', p, 5)

// 根据龙江吗的code获取学生id
export const codeGetStudentId = p => GET('/questionnaire/qr-code/getStudentId', p, 5)

// 根据龙江吗的code获取学生信息
export const codeGetStudentInfo = p => GET('/studentv2/qr-code/getStudentByCode', p, 5)

//获取核酸统计导出动态列
export const getNucleticColnum = p => GETNEW('/questionnaire/scan-query-field/list', p, 4)


// 最美人选投票统计
// 投票统计分页查询
export const getVoteStaticTabelData = p => POSTNEW('/questionnaire/votePerson/page', p, 5)

// 导出最美人选被投票人
export const exportSelectionPeople = p => EXPORTNEW('/questionnaire/votePerson/export', p, 5)

// 投票人员分页查询
export const getVoteRTabelData = p => POSTNEW('/questionnaire/vote/page', p, 5)

// 被投票人员详细信息
export const getVoterlData = p => GETNEW('/questionnaire/votePerson/getDetailById', p, 5)

// 导出最美人选投票人
export const exportVoteRTabelDatatPeople = p => EXPORTNEW('/questionnaire/vote/export', p, 5)


// WEBPACK FOOTER //
// ./src/api/modules/questionnaire.js